import React from "react";

const Yachts = () => {
  return (
    <>
      <section
  className="tour-area position-relative bg-top-center overflow-hidden space"
  id="service-sec"
  style={{ paddingTop: 50 }}
>
  <div className="container">
    <h2 className="text-center">Private Yachts</h2>
    <h5 className="text-center">Essential Fleet</h5>
    <p className="text-center">
      Best rates, essentials included, great for quick outings.
    </p>
    <div className="row g-4 mt-5">
      {/* Card 1 */}
      <div className="col-lg-3 col-md-6">
        <div className="indiaboats-card">
          <img
            src="assets/img/boat1.jpg"
            className="indiaboats-card-img"
            alt="Yacht 1"
          />
          <div className="indiaboats-card-body">
            <h5 className="indiaboats-card-title">Luxury Yacht One</h5>
            <p className="indiaboats-card-p">Capacity: 20PAX</p>
            <a href="selectPax.html" className="indiaboats-book-btn">
              Book Now
            </a>
          </div>
        </div>
      </div>
      {/* Card 2 */}
      <div className="col-lg-3 col-md-6">
        <div className="indiaboats-card">
          <img
            src="assets/img/boat2.jpg"
            className="indiaboats-card-img"
            alt="Yacht 2"
          />
          <div className="indiaboats-card-body">
            <h5 className="indiaboats-card-title">Ocean Pearl</h5>
            <p className="indiaboats-card-p">Capacity: 20PAX</p>
            <a href="selectPax.html" className="indiaboats-book-btn">
              Book Now
            </a>
          </div>
        </div>
      </div>
      {/* Card 3 */}
      <div className="col-lg-3 col-md-6">
        <div className="indiaboats-card">
          <img
            src="assets/img/boat3.jpg"
            className="indiaboats-card-img"
            alt="Yacht 3"
          />
          <div className="indiaboats-card-body">
            <h5 className="indiaboats-card-title">Sea Legend</h5>
            <p className="indiaboats-card-p">Capacity: 20PAX</p>
            <a href="selectPax.html" className="indiaboats-book-btn">
              Book Now
            </a>
          </div>
        </div>
      </div>
      {/* Card 4 */}
      <div className="col-lg-3 col-md-6">
        <div className="indiaboats-card">
          <img
            src="assets/img/deals1.jpg"
            className="indiaboats-card-img"
            alt="Yacht 4"
          />
          <div className="indiaboats-card-body">
            <h5 className="indiaboats-card-title">Royal Cruiser</h5>
            <p className="indiaboats-card-p">Capacity: 20PAX</p>
            <a href="selectPax.html" className="indiaboats-book-btn">
              Book Now
            </a>
          </div>
        </div>
      </div>
    </div>
    <h5 className="text-center mt-5">Signature Fleet</h5>
    <p className="text-center">
      Newer or higher-rated boats, priority service &amp; nicer amenities.
    </p>
    <div className="row g-4 mt-5">
      {/* Card 5 */}
      <div className="col-lg-3 col-md-6">
        <div className="indiaboats-card">
          <img
            src="assets/img/deals2.jpg"
            className="indiaboats-card-img"
            alt="Yacht 5"
          />
          <div className="indiaboats-card-body">
            <h5 className="indiaboats-card-title">Blue Horizon</h5>
            <p className="indiaboats-card-p">Capacity: 20PAX</p>
            <a href="selectPax.html" className="indiaboats-book-btn">
              Book Now
            </a>
          </div>
        </div>
      </div>
      {/* Card 6 */}
      <div className="col-lg-3 col-md-6">
        <div className="indiaboats-card">
          <img
            src="assets/img/deals4.jpg"
            className="indiaboats-card-img"
            alt="Yacht 6"
          />
          <div className="indiaboats-card-body">
            <h5 className="indiaboats-card-title">Ocean Dream</h5>
            <p className="indiaboats-card-p">Capacity: 20PAX</p>
            <a href="selectPax.html" className="indiaboats-book-btn">
              Book Now
            </a>
          </div>
        </div>
      </div>
      {/* Card 7 */}
      <div className="col-lg-3 col-md-6">
        <div className="indiaboats-card">
          <img
            src="assets/img/boat1.jpg"
            className="indiaboats-card-img"
            alt="Yacht 7"
          />
          <div className="indiaboats-card-body">
            <h5 className="indiaboats-card-title">Elite Sailor</h5>
            <p className="indiaboats-card-p">Capacity: 20PAX</p>
            <a href="selectPax.html" className="indiaboats-book-btn">
              Book Now
            </a>
          </div>
        </div>
      </div>
      {/* Card 8 */}
      <div className="col-lg-3 col-md-6">
        <div className="indiaboats-card">
          <img
            src="assets/img/boat2.jpg"
            className="indiaboats-card-img"
            alt="Yacht 8"
          />
          <div className="indiaboats-card-body">
            <h5 className="indiaboats-card-title">Golden Wave</h5>
            <p className="indiaboats-card-p">Capacity: 20PAX</p>
            <a href="selectPax.html" className="indiaboats-book-btn">
              Book Now
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </>
  );
};

export default Yachts;
